import "./Home.module.css";
import EnTêteDeNavigation from "@/reusable_sections/Header";
import StrategicVision from "./sections/StrategicVision";
import NotreApprocheMethodologique from "./sections/NotreApprocheMethodologique";
import PiliersDexpertise from "./sections/PiliersDexpertise";
import EngagementsValeurs from "./sections/EngagementsValeurs";
import ApercuDeNosRealisations from "./sections/ApercuDeNosRealisations";
import IlsNousFontConfiance from "./sections/IlsNousFontConfiance";
import LancerUnProjet from "./sections/LancerUnProjet";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <EnTêteDeNavigation />
      <StrategicVision />
      <NotreApprocheMethodologique />
      <PiliersDexpertise />
      <EngagementsValeurs />
      <ApercuDeNosRealisations />
      <IlsNousFontConfiance />
      <LancerUnProjet />
      <Footer />
    </div>;
}